export class Classifications {
    id: string;
    name: string;
    parent_id: string;
    is_default: string;
    
    creation_user: string;
    creation_ip: string;
    created_at: string;

    last_update_user:string;
    last_update_ip:string;
    on_behalf_of:string;
    last_on_behalf_of:string;
    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/classifications/classifications.ts